/* eslint-disable no-empty-pattern */
import { MODULE_NAME } from './const';
import { activeAccountId, account, userAccounts } from './getters';
import {
	MEMBERS,
	ADD_MEMBERS,
	//	REMOVE_TEMP_MEMBER,
	// UPDATE_ROLE,
	// UPDATE_ACTIVE,
	SET_ACCOUNT,
	SET_USER_ACCOUNTS,
	SET_ACTIVE_ACCOUNT_ID,
	DELETE_ACCOUNT,
} from './mutations';
import state from './state';
import StoreModuleService from '../StoreModuleService';
import api, { saveAuthLogo as saveAuthLogoApiCall } from '@/api';
import store from '@/store';
import ExtensionCommunicationService from '@/utils/extension-communication-service';
// import { StatusCodes } from 'http-status-codes';

const buildAccountActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const getAccountMembers = buildAccountActionObject('getAccountMembers');
export const inviteToAccount = buildAccountActionObject('inviteToAccount');
export const revokeInvitation = buildAccountActionObject('revokeInvitation');
export const updateRoles = buildAccountActionObject('updateRoles');
export const updateUsersState = buildAccountActionObject('updateUsersState');
export const resendInvitation = buildAccountActionObject('resendInvitation');
export const addCname = buildAccountActionObject('addCname');
export const removeCname = buildAccountActionObject('removeCname');
export const updateAccount = buildAccountActionObject('updateAccount');
export const acceptChangeAccountOwner = buildAccountActionObject('acceptChangeAccountOwner');
export const sendChangeAccountOwnerMail = buildAccountActionObject('sendChangeAccountOwnerMail');
export const acceptDeleteAccount = buildAccountActionObject('acceptDeleteAccount');
export const sendDeleteAccountMail = buildAccountActionObject('sendDeleteAccountMail');
export const setActiveAccountId = buildAccountActionObject('setActiveAccountId');
export const setUserAccounts = buildAccountActionObject('setUserAccounts');
export const removeUserFromAccount = buildAccountActionObject('removeUserFromAccount');
export const removeAccount = buildAccountActionObject('removeAccount');
export const saveWorkspaceAvatar = buildAccountActionObject('saveWorkspaceAvatar');
export const saveAuthLogo = buildAccountActionObject('saveAuthLogo');
export const getActiveAccount = buildAccountActionObject('getActiveAccount');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [getActiveAccount.action]({ commit, getters }) {
		const account = await api.getAccount(getters[activeAccountId.getter]);
		commit(SET_ACCOUNT, account);
		return account;
	},
	async [saveWorkspaceAvatar.action]({ commit, getters }, payload) {
		const { avatar } = payload;
		const account = await api.saveWorkspaceAvatar(getters[activeAccountId.getter], avatar);
		commit(SET_ACCOUNT, account);
		return account;
	},
	async [saveAuthLogo.action]({ commit, getters }, payload) {
		const { avatar } = payload;
		const account = await saveAuthLogoApiCall(getters[activeAccountId.getter], avatar);
		commit(SET_ACCOUNT, account);
		return account;
	},
	async [removeUserFromAccount.action]({ dispatch }, payload) {
		const { userId, accountId } = payload;
		try {
			await api.removeUserFromAccount(userId, accountId);
			dispatch(removeAccount.action, { id: accountId });
		} catch (e) {
			console.error('error removeUserFromAccount - ', e);
		}
	},
	[removeAccount.action]({ dispatch, getters }, payload) {
		const allUserAccounts = getters[userAccounts.getter];
		const newUserAccounts = allUserAccounts.filter((accountLink) => accountLink.account.id !== payload.id);
		dispatch(setUserAccounts.action, { accounts: newUserAccounts });
	},
	[setActiveAccountId.action]({ commit }, payload) {
		commit(SET_ACTIVE_ACCOUNT_ID, payload.id);
	},
	[setUserAccounts.action]({ commit }, payload) {
		commit(SET_USER_ACCOUNTS, payload.accounts);
	},
	async [getAccountMembers.action]({ commit, getters }, payload) {
		const forceGet = payload?.forceGet;
		const needToGet = !state.members?.length > 0;
		const shouldGet = forceGet || needToGet;
		if (getters[activeAccountId.getter] && shouldGet) {
			store.dispatch('billing/getCustomerData', null, { root: true }); // cant dispatch regularly because of circular dependency
			const ret = await api.getAccountMembers(getters[activeAccountId.getter]);
			commit(MEMBERS, ret);
			return ret;
		}
	},
	async [inviteToAccount.action]({ commit, getters }, payload) {
		const { emails, role } = payload;
		const ret = await api.inviteToAccount(getters[activeAccountId.getter], emails, role);
		commit(ADD_MEMBERS, ret);
		return ret;
	},
	async [revokeInvitation.action]({ dispatch, getters }, payload) {
		const { uID } = payload;
		const ret = await api.revokeInvitation(getters[activeAccountId.getter], uID);
		dispatch(getAccountMembers.action, { forceGet: true });
		return ret;
	},
	async [updateRoles.action]({ getters, dispatch }, payload) {
		const { users, roleCode } = payload;
		await api.updateRoles(getters[activeAccountId.getter], users, roleCode);
		dispatch(getAccountMembers.action, { forceGet: true });
		// commit(UPDATE_ROLE, payload);
	},
	async [updateUsersState.action]({ dispatch, getters }, payload) {
		const { users, activate } = payload;
		const ret = await api.updateUsersState(getters[activeAccountId.getter], users, activate);
		dispatch(getAccountMembers.action, { forceGet: true });
		return ret;
	},
	async [resendInvitation.action]({ getters }, payload) {
		const { uID } = payload;
		const ret = await api.resendInvitation(getters[activeAccountId.getter], uID);
		return ret;
	},
	async [addCname.action]({ commit, getters }, payload) {
		const { cname, serviceId } = payload;

		const getURLFromCname = (cname) => {
			const urlHasProtocol = cname.includes('http://') || cname.includes('https://');
			return urlHasProtocol ? new URL(cname) : new URL(`https://${cname}`);
		};

		const cnameURL = getURLFromCname(cname);
		const ret = await api.addCname(getters[activeAccountId.getter], serviceId, cname);
		ExtensionCommunicationService.askForPermissionIfExtensionInstalled(`${cnameURL.protocol}//${cnameURL.hostname}`);
		const { cnames: newCnames } = ret;
		commit(SET_ACCOUNT, { ...getters[account.getter], configs: { ...getters[account.getter].configs, cnames: newCnames } });
		return ret;
	},
	async [removeCname.action]({ commit, getters }, payload) {
		const { cname, serviceId } = payload;
		const ret = await api.removeCname(getters[activeAccountId.getter], serviceId, cname);
		const { cnames: newCnames } = ret;
		commit(SET_ACCOUNT, { ...getters[account.getter], configs: { ...getters[account.getter].configs, cnames: newCnames } });
		return ret;
	},
	async [updateAccount.action]({ commit, getters }, fields) {
		const response = await api.updateAccount(getters[activeAccountId.getter], fields);
		commit(SET_ACCOUNT, response);
		return response;
	},
	async [sendChangeAccountOwnerMail.action]({ getters }, payload) {
		const { password, userAccountId } = payload;
		await api.sendChangeAccountOwnerMail(getters[activeAccountId.getter], { password, user_account: userAccountId });
	},
	async [acceptChangeAccountOwner.action]({ commit, dispatch }, payload) {
		const { user } = payload;
		const ret = await api.acceptChangeAccountOwner(user);
		if (ret.account) {
			commit(SET_ACCOUNT, ret.account);
			dispatch(getAccountMembers.action, { forceGet: true });
		}
	},
	async [sendDeleteAccountMail.action]({ getters }) {
		await api.sendDeleteAccountMail(getters[activeAccountId.getter]);
	},
	async [acceptDeleteAccount.action]({ commit }, payload) {
		const { account } = payload;
		const ret = await api.acceptDeleteAccount(account);
		if (ret.account_id) {
			commit(DELETE_ACCOUNT, ret.account_id);
		}
	},
};

export default actions;
